import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Col from "./Col.js";
import { getRowProps, getContainerWithProps, getColProps, instanceOfGrid } from "./Grid.utils.js";
import Row from "./Row.js";
import './Grid.css';/* empty css          */
const Grid = ({
  grid,
  renderItem,
  renderGrid
}) => {
  const { items } = grid;
  const { gutter, className, ...rowProps } = getRowProps(grid);
  const { Container: GridContainer, props: gridContainerProps } = getContainerWithProps(grid);
  return /* @__PURE__ */ jsx(GridContainer, { ...gridContainerProps, children: /* @__PURE__ */ jsx(Row, { ...rowProps, gutter, className: classnames("perxis-auto-grid", className), children: items.map((item) => {
    const isGrid = instanceOfGrid(item);
    const { Container: GridItemContainer, props: gridItemContainerProps } = getContainerWithProps(item);
    let element = null;
    if (isGrid) {
      if (renderGrid) {
        element = renderGrid(item);
      } else {
        element = /* @__PURE__ */ jsx(Grid, { renderItem, renderGrid, grid: item }, item.id);
      }
    } else {
      const renderedItem = renderItem(item);
      if (renderedItem) {
        element = /* @__PURE__ */ jsx(GridItemContainer, { ...gridItemContainerProps, children: renderedItem }, item.id);
      }
    }
    const { id } = item;
    const colProps = getColProps(item);
    if (!element) {
      return null;
    }
    return /* @__PURE__ */ jsx(Col, { ...colProps, children: element }, id);
  }) }) });
};
export {
  Grid as default
};
//# sourceMappingURL=Grid.js.map
